import {Utils} from 'components/shared';

var keyModifier = Utils.getKeyModifier();

var defaultKeymap = {
    ArrParent: {
        newOutput: keyModifier + 'n', //CREATE_NEW_OUTPUT
    },
};

export default defaultKeymap;
